import React from 'react'

import { Column, Text } from 'Components/UI'
import { DateTime } from 'luxon'
import { EventItem } from 'Types/emajinAPI'

import { Divider } from './styles'
import TextRow, { EventsListGalleryCardTextRowKind } from './TextRow'

type Props = {
  data?: EventItem
  onOpenLocation?: () => void
}

function EventDetailsTitles({ data, onOpenLocation }: Props) {
  if (!data) return null

  return (
    <Column fullWidth gap={3} py={5}>
      {data.date && (
        <TextRow
          kind={EventsListGalleryCardTextRowKind.Date}
          text={DateTime.fromISO(data.date).toFormat('dd MMMM yyyy')}
        />
      )}

      {data.venueName && (
        <TextRow
          kind={EventsListGalleryCardTextRowKind.Name}
          text={`${data.venueName}${data.location ? `, ${data.location}` : ''}`}
        />
      )}

      <Divider my={4} />

      {data.name && (
        <Text bold important mb={5} screen18>
          {data.name}
        </Text>
      )}

      {data.presenterName && (
        <TextRow
          kind={EventsListGalleryCardTextRowKind.Presenter}
          text={`${data.presenterName}${
            data.presenterJobTitle ? `, ${data.presenterJobTitle}` : ''
          }`}
        />
      )}

      <TextRow
        clickable={!!data.coordinate?.lat && !!data.coordinate?.lng}
        kind={EventsListGalleryCardTextRowKind.Address}
        text={data.address ?? ''}
        onClick={onOpenLocation}
      />
    </Column>
  )
}

export default EventDetailsTitles
